import sortBy from 'lodash/sortBy'

export const DIFF_TEXT_COLUMNS_PROP = 'textDiffRows'

export function collectiondifferences(newItems = [], previousItems = [], objectComparisonProp = 'name') {
   const previousItemsValue = new Set(previousItems?.map(obj => obj?.[objectComparisonProp]))

   const differenceObjects = []
   const sameItems = []

   newItems?.forEach((obj, idx) => {
      delete newItems[idx].new
      if (!previousItemsValue.has(obj?.[objectComparisonProp])) differenceObjects.push({ ...obj, new: true })
      else sameItems.push(obj)
   })

   const result = sortBy([...differenceObjects, ...sameItems], objectComparisonProp)
   return result
}

const nestedDifferences = (actualProperty, previousProperty, accessor) => {
   const levels = accessor.split('.')
   const propertyName = levels.at(-1)
   levels.pop()
   const objRoute = levels.join('.')
   const getActualNestedObj = actualProperty?.[objRoute]
   const getPreviousNestedObj = previousProperty?.[objRoute]
   return [collectiondifferences(getActualNestedObj, getPreviousNestedObj, propertyName), objRoute]
}

export const findAndInsertDifferences = (collection = [], nestedColumns = {}, objectComparisonProp = 'name') => {
   const arrLength = collection?.length
   if (arrLength < 2) return collection
   const collectionsKeys = Object.keys(collection?.[0])

   for (let i = 1; i < arrLength; i++) {
      const result = []
      collectionsKeys?.forEach(key => {
         const actualProperty = collection?.[i]?.[key]
         const previousProperty = collection?.[i - 1]?.[key]

         if (Array.isArray(actualProperty)) {
            const mainObject = collectiondifferences(actualProperty, previousProperty, objectComparisonProp)
            // const accessor = nestedColumns?.[key]
            // if (accessor) {
            //    const [data, objRoute] = nestedDifferences({...actualProperty}, {...previousProperty}, accessor)
            //    console.log('data:', data)
            //    collection[i][key] = { ...mainObject, [objRoute]: data }
            // } else 
               collection[i][key] = mainObject
         } else {
            previousProperty !== actualProperty && result.push(key)
            collection[i][DIFF_TEXT_COLUMNS_PROP] = result
         }
      })
   }
   return collection
}

export const differencesMapper = ({ content, pageable, docTypesOptions, ...row }) => {
   const nestedColumns = { grupos: 'roles.name' }
   const values = findAndInsertDifferences(content, nestedColumns)
   
   if (pageable?.pageNumber) values.shift()

   return {
      data: values?.map(user => ({
         ...user,
         id: user?.item,
         adminUser: user?.adminUser ? 'SI' : 'NO',
         userType: user?.userType == 'I' ? 'Interno' : 'Externo',
         documentType: docTypesOptions?.[user?.documentType]?.label,
         lastModifiedDate: new Date(user?.lastModifiedDate)?.toLocaleDateString() || ''
      })),
      pageSize: pageable?.pageSize,
      pageNumber: pageable?.pageNumber,
      totalRows: row?.totalElements
   }
}
